"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _core = require("@material-ui/core");

var _Icon = _interopRequireDefault(require("./Icon"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
} // eslint-disable-next-line react/prop-types


var MenuItemInner = function MenuItemInner(_ref, ref) {
  var icon = _ref.icon,
      label = _ref.label,
      onClick = _ref.onClick,
      children = _ref.children,
      otherProps = _objectWithoutProperties(_ref, ["icon", "label", "onClick", "children"]);

  return _react.default.createElement(_core.MenuItem, _extends({
    ref: ref,
    button: true,
    onClick: onClick
  }, otherProps), icon ? _react.default.createElement(_core.ListItemIcon, null, _react.default.createElement(_Icon.default, null, icon)) : null, _react.default.createElement(_core.ListItemText, {
    primary: label,
    primaryTypographyProps: {
      noWrap: true
    }
  }), children);
};

var MenuItem = _react.default.forwardRef(MenuItemInner);

MenuItem.propTypes = {
  icon: _propTypes.default.string,
  label: _propTypes.default.string,
  onClick: _propTypes.default.func,
  children: _propTypes.default.node
};
var _default = MenuItem;
exports.default = _default;